import { ListWithTotals, ChallengeDto, UserToChallengeDto, ChallengesFilter } from '@sweatpals/shared';
import { AxiosInstance } from 'axios';

export class ChallengeService {
	private readonly basePath = 'challenges';

	constructor(private readonly httpClient: AxiosInstance) {}

	public async getAllPublicChallenges(): Promise<ListWithTotals<ChallengeDto>> {
		const { data } = await this.httpClient.get<ListWithTotals<ChallengeDto>>(`${this.basePath}/public/search`);
		return data;
	}

	public async getChallengeByAlias(alias: string): Promise<ChallengeDto> {
		const { data } = await this.httpClient.get<ChallengeDto>(`${this.basePath}/public/${alias}`);
		return data;
	}

	public async getChallengeMembers(id: string, filter?: ChallengesFilter): Promise<ListWithTotals<UserToChallengeDto>> {
		const { data } = await this.httpClient.get<ListWithTotals<UserToChallengeDto>>(
			`${this.basePath}/public/challenge/${id}/members`,
			{ params: filter }
		);
		return data;
	}
}
